<div class="loader-background">
    <div class="centering">
        <img class="spinner-loader" src="../../../assets/img/car-loader-white.svg" alt="app-loader" />
        <h4 id="phrase" class="loading-info">{{ ' ' }}</h4>
    </div>
</div>
